import React from "react";
import { RoleAssignContextProvider } from "./RoleAssignView";
import RoleAssign from "./view/RoleAssign";

const RoleAssignPage = () => {
  return (
    <RoleAssignContextProvider>
        <RoleAssign/>
    </RoleAssignContextProvider>
  );
};

export default RoleAssignPage;
